import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule, Routes} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { LogicielCaisseInterceptor } from 'app/auth/helpers/logiciel-caisse.interceptor';
import { LogicielCaisseAuthGuard } from 'app/auth/helpers/logiciel-caisse-auth.guard';
import { LogicielCaisseParametreModule } from './main/pages/logiciel-caisse/logiciel-caisse-parametre.module';
import { LogicielCaisseEntrepotsComponent } from './main/pages/logiciel-caisse/entrepots/logiciel-caisse-entrepots.component';
import { LogicielCaisseCaissesComponent } from './main/pages/logiciel-caisse/caisses/logiciel-caisse-caisses.component';
import { LogicielCaisseGerantEntrepotComponent } from './main/pages/logiciel-caisse/gerant-entrepot/logiciel-caisse-gerant-entrepot.component';
import { LogicielCaisseVendeurCaisseComponent } from './main/pages/logiciel-caisse/vendeur-caisse/logiciel-caisse-vendeur-caisse.component';
import { LogicielCaisseEtablissementsComponent } from './main/pages/logiciel-caisse/etablissements/logiciel-caisse-etablissements.component';
import { LogicielCaisseTicketTemplatesComponent } from './main/pages/logiciel-caisse/ticket-templates/logiciel-caisse-ticket-templates.component';
import { LogicielCaisseTypeModePaimentComponent } from './main/pages/logiciel-caisse/type-mode-paiment/logiciel-caisse-type-mode-paiment.component';
import { LogicielCaisseSetupDashboardComponent } from './main/pages/logiciel-caisse/setup-dashboard/logiciel-caisse-setup-dashboard.component';
import { LogicielCaisseSetupWizardComponent } from './main/pages/logiciel-caisse/setup-wizard/logiciel-caisse-setup-wizard.component';
import { LogicielCaisseGestionStockComponent } from './main/pages/logiciel-caisse/gestion-stock/logiciel-caisse-gestion-stock.component';
import { LogicielCaisseGestionStockTabComponent } from './main/pages/logiciel-caisse/gestion-stock/logiciel-caisse-gestion-stock-tab.component';
import 'hammerjs';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {ToastrModule} from 'ngx-toastr';
import {FormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {BootstrapToastComponent} from 'app/shared/bootstrap-toast/bootstrap-toast.component';
import {CoreModule} from '@core/core.module';
import {CoreCommonModule} from '@core/common.module';
import {CoreSidebarModule, CoreThemeCustomizerModule} from '@core/components';
import {coreConfig} from 'app/app-config';
import {AppComponent} from 'app/app.component';
import {LayoutModule} from 'app/layout/layout.module';
import {ErpAffichagesModule} from 'app/shared/erp-affichages/erp-affichages.module';
import {MainParametreComponent} from './main/parametre/main-parametre/main-parametre.component';
import {ParametreDocumentComponent} from './main/parametre/parametre-document/parametre-document.component';
import {CompteBancaireComponent} from './main/parametre/compte-bancaire/compte-bancaire.component';
import {TaxeTvaComponent} from './main/parametre/taxe-tva/taxe-tva.component';
import {ListePrixComponent} from './main/parametre/liste-prix/liste-prix.component';
import {ComptableParametreComponent} from './main/parametre/comptable-parametre/comptable-parametre.component';
import {UserandroleComponent} from './main/parametre/userandrole/userandrole.component';
import {IntegrationParametreComponent} from './main/parametre/integration-parametre/integration-parametre.component';
import {ParametreDbComponent} from './main/parametre/parametre-db/parametre-db.component';
import {ParametreDonneesShellComponent} from './main/parametre/parametre-donnees/parametre-donnees-shell/parametre-donnees-shell.component';
import {ParametreDonneesModuleComponent} from './main/parametre/parametre-donnees/parametre-donnees-module/parametre-donnees-module.component';
import {ParametreDonneesDataTableComponent} from './main/parametre/parametre-donnees/parametre-donnees-data-table/parametre-donnees-data-table.component';
import {ParametreDonneesChampsTabComponent} from './main/parametre/parametre-donnees/parametre-donnees-champs-tab/parametre-donnees-champs-tab.component';
import {ParametreDonneesAffichageTabComponent} from './main/parametre/parametre-donnees/parametre-donnees-affichage-tab/parametre-donnees-affichage-tab.component';
import {ParametreDonneesReglesTabComponent} from './main/parametre/parametre-donnees/parametre-donnees-regles-tab/parametre-donnees-regles-tab.component';
import {ParametreDonneesUtilisationTabComponent} from './main/parametre/parametre-donnees/parametre-donnees-utilisation-tab/parametre-donnees-utilisation-tab.component';
import {ParametreDonneesImportTabComponent} from './main/parametre/parametre-donnees/parametre-donnees-import-tab/parametre-donnees-import-tab.component';
import {ParametreDonneesExportTabComponent} from './main/parametre/parametre-donnees/parametre-donnees-export-tab/parametre-donnees-export-tab.component';
import {ParametreDonneesApiTabComponent} from './main/parametre/parametre-donnees/parametre-donnees-api-tab/parametre-donnees-api-tab.component';
import {ParametreDonneesHistoriqueTabComponent} from './main/parametre/parametre-donnees/parametre-donnees-historique-tab/parametre-donnees-historique-tab.component';
import {ProjectParametreComponent} from './main/parametre/project-parametre/project-parametre.component';
import {MarqueAndCategoryComponent} from './main/parametre/marque-and-category/marque-and-category.component';
import {DocAchatComponent} from './main/parametre/parametre-document/doc-achat/doc-achat.component';
import {DocVenteComponent} from './main/parametre/parametre-document/doc-vente/doc-vente.component';
import {
    DocAchatCommandeClientComponent
} from './main/parametre/parametre-document/doc-achat/doc-achat-commande-client/doc-achat-commande-client.component';
import {
    DocAchatInventaireComponent
} from './main/parametre/parametre-document/doc-achat/doc-achat-inventaire/doc-achat-inventaire.component';
import {
    DocAchatFactureFornisseurComponent
} from './main/parametre/parametre-document/doc-achat/doc-achat-facture-fornisseur/doc-achat-facture-fornisseur.component';
import {
    DocAchatBonLivraisonComponent
} from './main/parametre/parametre-document/doc-achat/doc-achat-bon-livraison/doc-achat-bon-livraison.component';
import {
    DocAchatCommandeFornisseurComponent
} from './main/parametre/parametre-document/doc-achat/doc-achat-commande-fornisseur/doc-achat-commande-fornisseur.component';
import {DocumentAppercueComponent} from './main/parametre/apprecu-document/document-appercue/document-appercue.component';
import {ParametreTvaComponent} from './main/parametre/taxe-tva/parametre-tva/parametre-tva.component';
import {ErpParametreTaxeComponent} from '@erp/affichages';
import {AuthGuard} from 'app/auth/helpers/auth.guards';
import {RegisterComponent} from './main/pages/authentication/register/register.component';
import {ForgetPasswordComponent} from './main/pages/authentication/forget-password/forget-password.component';
import {LoginLayoutComponent} from './layout/login-layout/login-layout.component';
import {VerifEmailComponent} from './main/pages/authentication/verif-email/verif-email.component';
import {CreateStationComponent} from './main/pages/authentication/create-station/create-station.component';
import {animation} from '@angular/animations';
import {CroudUserComponent} from './main/parametre/userandrole/croud-user/croud-user.component';
import {CroudIntegrationComponent} from './main/parametre/integration-parametre/croud-integration/croud-integration.component';
import {ParametreUniteComponent} from './main/parametre/marque-and-category/parametre-unite/parametre-unite.component';
import {ParametreMarqueComponent} from './main/parametre/marque-and-category/parametre-marque/parametre-marque.component';
import {ParametreCategoriesComponent} from './main/parametre/marque-and-category/parametre-categories/parametre-categories.component';
import {CroudMarqueCategoryComponent} from './main/parametre/marque-and-category/croud-marque-category/croud-marque-category.component';
import {AddMenuComponent} from './main/parametre/marque-and-category/add-menu/add-menu.component';
import {Ng2FlatpickrModule} from 'ng2-flatpickr';
import {NgSelectModule} from '@ng-select/ng-select';
import {ProfileEntrepriseComponent} from './main/parametre/profile-entreprise/profile-entreprise.component';
import {AjoutIntegrationComponent} from './main/parametre/integration-parametre/ajout-integration/ajout-integration.component';
import {ApproveVenteComponent} from './main/pages/Vente/devis/approve-vente/approve-vente.component';
import {ApproveVenteNegoceComponent} from './main/pages/VenteNegoce/devis/approve-vente/approve-vente-negoce.component';
import {
    FournissDetailChiffreFactureComponent
} from './main/pages/fournisseur/details-fourniss/fourniss-detail-chiffre-facture-fr/fourniss-detail-chiffre-facture.component';
import {
    DocVenteDevisComponent
} from './main/parametre/parametre-document/doc-vente/doc-vente-devis/doc-vente-devis.component';
import {
    DocVenteCommandeClientComponent
} from './main/parametre/parametre-document/doc-vente/doc-vente-commande-client/doc-vente-commande-client.component';
import {
    DocVenteBonLivraisonComponent
} from './main/parametre/parametre-document/doc-vente/doc-vente-bon-livraison/doc-vente-bon-livraison.component';
import {
    DocVenteFactureComponent
} from './main/parametre/parametre-document/doc-vente/doc-vente-facture/doc-vente-facture.component';
import {
    DocVenteBonSortieComponent
} from './main/parametre/parametre-document/doc-vente/doc-vente-bon-sortie/doc-vente-bon-sortie.component';
import {BontransfertTableComponent} from './main/pages/stock/bon-transfert/bontransfert-table/bontransfert-table.component';
import {ApercueComponent} from './main/pages/shared/apercue/apercue.component';
import {AuthLoginV2Component} from './main/pages/authentication/auth-login-v2/auth-login-v2.component';
import {AddFournissComponent} from './main/pages/shared/add-fourniss/add-fourniss.component';
import {AvoirComponent} from './main/pages/Vente/avoir/avoir.component';
import {AvoirNegoceComponent} from './main/pages/VenteNegoce/avoir/avoir-negoce.component';
import {AvoirTabContentComponent} from './main/pages/Vente/avoir/avoir-tab-content/avoir-tab-content.component';
import {AvoirTabContentNegoceComponent} from './main/pages/VenteNegoce/avoir/avoir-tab-content/avoir-tab-content-negoce.component';
import {AvoirFournisseurComponent} from './main/pages/Achat/avoir-fournisseur/avoir-fournisseur.component';
import {AvoirFournisseurTabContentComponent} from './main/pages/Achat/avoir-fournisseur/avoir-fournisseur-tab-content/avoir-fournisseur-tab-content.component';
import {IconsModule} from './icons/icons.module';
import {PagesModule} from './main/pages/pages.module';
import {HttpLoadingInterceptor} from '@core/interceptors/http-loading.interceptor';
import {ParametreNavHttpInterceptor} from 'app/services/parametre/parametre-nav-http.interceptor';
import {AppNavHttpInterceptor} from 'app/services/navigation/app-nav-http.interceptor';
import {JwtInterceptor} from 'app/auth/helpers/jwt.interceptor';


const appRoutes: Routes = [
    {
        path: 'register',
        component: RegisterComponent,
        data: {animation: 'EmailComponent'},
    },
    {
        path: 'token',
        component: VerifEmailComponent,
        data: {animation: 'EmailComponent'},
        canActivate: [AuthGuard]
    },
    {
        path: 'create-station',
        component: CreateStationComponent,
        data: {animation: 'EmailComponent'},
        canActivate: [AuthGuard]
    },
    {
        path: 'pages',
        loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
    },
    {
        path :'login',
        component : AuthLoginV2Component
    },


    {
        path: 'main/parametre',
        component: MainParametreComponent,
      //  data: {animation: 'EntreprisePage'},
        canActivate: [AuthGuard],
        children: [
            {
                path: 'entreprise',
                component: ProfileEntrepriseComponent,
                //   data: { animation: 'EmailComponent' },
                 canActivate: [AuthGuard]
            },
            {
                path: 'document',
                component: ParametreDocumentComponent,
                //  data: { animation: 'EmailComponent' }
            }
            ,
            {
                path: 'compte-bancaire',
                component: CompteBancaireComponent,
                //  data: { animation: 'EmailComponent' }
            }
            ,
            {
                path: 'document/achat',
                component: DocAchatComponent,
                //  data: { animation: 'EmailComponent' },
                children: [
                    {
                        path: '',
                        component: DocAchatInventaireComponent
                    },
                    {
                        path: 'commande-fornisseur',
                        component: DocAchatCommandeFornisseurComponent
                    },
                    {
                        path: 'facture-fornisseur',
                        component: DocAchatFactureFornisseurComponent
                    },
                    {
                        path: 'bon-livraison',
                        component: DocAchatBonLivraisonComponent
                    },
                ]
            }
            ,
            {
                path: 'document/vente',
                component: DocVenteComponent,
                //     data: {animation: 'EmailComponent'},
                children: [
                    {
                        path: '',
                        component: DocVenteDevisComponent
                    },
                    {
                        path: 'commande-client',
                        component: DocVenteCommandeClientComponent
                    },
                    {
                        path: 'bon-livraison',
                        component: DocVenteBonLivraisonComponent
                    },
                    {
                        path: 'facture',
                        component: DocVenteFactureComponent
                    },
                    {
                        path: 'bon-sortie',
                        component: DocVenteBonSortieComponent
                    }


                ]
            },
            {
                path: 'taxe-tva',
                component: TaxeTvaComponent,
                //  data: { animation: 'EmailComponent' },
                children: [
                    {
                        path: '',
                        component: ErpParametreTaxeComponent
                    },
                    {
                        path: 'taxe',
                        component: ErpParametreTaxeComponent
                    },
                    {
                        path: 'tva',
                        component: ParametreTvaComponent
                    },
                ]
            }
            ,
            {
                path: 'liste-prix',
                component: ListePrixComponent,
                //  data: { animation: 'EmailComponent'}

            },
            {
                path: 'comptable-parametre',
                component: ComptableParametreComponent,
                data: {animation: 'EmailComponent'}

            },
            {
                path: 'user-and-role',
                component: UserandroleComponent,
                //    data: { animation: 'EmailComponent'},
            },
            {
                path: 'user-and-role/ajouter',
                component: CroudUserComponent,
                //  data: { animation: 'EmailComponent' }
            },
            {
                path: 'integration',
                component: IntegrationParametreComponent,
                //  data: { animation: 'EmailComponent'},
            },
            {
                path: 'donnees',
                component: ParametreDonneesShellComponent,
                children: [
                    { path: '', pathMatch: 'full', redirectTo: 'produits' },
                    { path: ':moduleKey', component: ParametreDonneesModuleComponent }
                ]
            },
            {
                path: 'projets',
                component: ProjectParametreComponent,
                // data: { animation: 'EmailComponent'},
            },
            {
                path: 'marque-categorie',
                component: MarqueAndCategoryComponent,
                // data: { animation: 'EmailComponent'},
                children: [
                    {
                        path: 'categories',
                        component: ParametreCategoriesComponent
                    },
                    {
                        path: 'unite',
                        component: ParametreUniteComponent
                    },
                    {
                        path: 'marque',
                        component: ParametreMarqueComponent
                    },
                ]
            },
            {
                path: 'logiciel-caisse',
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
                children: [
                    { path: '', component: LogicielCaisseSetupDashboardComponent },
                    { path: 'wizard', component: LogicielCaisseSetupWizardComponent },
                ],
            },
            {
                path: 'entrepots',
                component: LogicielCaisseEntrepotsComponent,
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
            },
            {
                path: 'caisses',
                component: LogicielCaisseCaissesComponent,
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
            },
            {
                path: 'gerant-entrepot',
                component: LogicielCaisseGerantEntrepotComponent,
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
            },
            {
                path: 'vendeur-caisse',
                component: LogicielCaisseVendeurCaisseComponent,
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
            },
            {
                path: 'etablissements',
                component: LogicielCaisseEtablissementsComponent,
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
            },
            {
                path: 'ticket-templates',
                component: LogicielCaisseTicketTemplatesComponent,
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
            },
            {
                path: 'modes-paiement',
                component: LogicielCaisseTypeModePaimentComponent,
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
            },
            {
                path: 'gestion-stock',
                component: LogicielCaisseGestionStockComponent,
                canActivate: [AuthGuard, LogicielCaisseAuthGuard],
                children: [
                    { path: '', redirectTo: 'actif', pathMatch: 'full' },
                    { path: 'actif', component: LogicielCaisseGestionStockTabComponent, data: { tab: 'actif' } },
                    { path: 'archive', component: LogicielCaisseGestionStockTabComponent, data: { tab: 'archive' } },
                ],
            },
        ]
    },
    {
        path: '',
        loadChildren: () => import('./main/sample/sample.module').then((m) => m.SampleModule),
    },
    {
        path: '**',
        redirectTo: '/pages/miscellaneous/error'
    }
];

@NgModule({
    declarations: [
        AppComponent,
        MainParametreComponent,
        ProfileEntrepriseComponent,
        ParametreDocumentComponent,
        TaxeTvaComponent,
        ListePrixComponent,
        ComptableParametreComponent,
        UserandroleComponent,
        IntegrationParametreComponent,
        ParametreDbComponent,
        ParametreDonneesShellComponent,
        ParametreDonneesModuleComponent,
        ParametreDonneesDataTableComponent,
        ParametreDonneesChampsTabComponent,
        ParametreDonneesAffichageTabComponent,
        ParametreDonneesReglesTabComponent,
        ParametreDonneesUtilisationTabComponent,
        ParametreDonneesImportTabComponent,
        ParametreDonneesExportTabComponent,
        ParametreDonneesApiTabComponent,
        ParametreDonneesHistoriqueTabComponent,
        ProjectParametreComponent,
        MarqueAndCategoryComponent,
        DocumentAppercueComponent,
        ParametreTvaComponent,
        DocAchatCommandeFornisseurComponent,
        DocAchatInventaireComponent,
        RegisterComponent,
        ForgetPasswordComponent,
        LoginLayoutComponent,
        CroudUserComponent,
        CroudIntegrationComponent,
        ParametreUniteComponent,
        ParametreMarqueComponent,
        ParametreCategoriesComponent,
        CroudMarqueCategoryComponent,
        AddMenuComponent,
        AjoutIntegrationComponent,
        ApproveVenteComponent,
        ApproveVenteNegoceComponent,
        DocAchatComponent,
        DocVenteComponent,
        DocVenteDevisComponent,
        DocVenteCommandeClientComponent,
        DocVenteBonLivraisonComponent,
        DocVenteFactureComponent,
        DocVenteBonSortieComponent,
        BontransfertTableComponent,
        ApercueComponent,
        ApproveVenteComponent,
        ApproveVenteNegoceComponent,
        AvoirComponent,
        AvoirTabContentComponent,
        AvoirNegoceComponent,
        AvoirTabContentNegoceComponent,
        AvoirFournisseurComponent,
        AvoirFournisseurTabContentComponent,
        BootstrapToastComponent

    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        NgxPaginationModule,
        NgbDropdownModule,
        NgbModule,
        ToastrModule.forRoot({
            toastComponent: BootstrapToastComponent,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
            timeOut: 60000,
            extendedTimeOut: 5000,
            progressBar: false,
            closeButton: true,
            newestOnTop: true,
            easeTime: 250,
            tapToDismiss: true,
            maxOpened: 1,
            autoDismiss: true,
            toastClass: 'ngx-toastr bs-toast-host',
        }),
        RouterModule.forRoot(appRoutes, {
            scrollPositionRestoration: 'enabled',
            relativeLinkResolution: 'legacy'
        }),
        TranslateModule.forRoot(),
        CoreModule.forRoot(coreConfig),
        CoreCommonModule,
        CoreSidebarModule,
        CoreThemeCustomizerModule,
        Ng2FlatpickrModule,
        LayoutModule,
        NgSelectModule,
        IconsModule,
        PagesModule,
        ErpAffichagesModule,
        LogicielCaisseParametreModule

    ],
    exports: [
        BontransfertTableComponent

    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpLoadingInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ParametreNavHttpInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppNavHttpInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LogicielCaisseInterceptor,
            multi: true
        }
    ],

    bootstrap: [AppComponent]
})
export class AppModule {
}
